
const groups = {
  SETUP:'SETUP',
  USER_ROLES: 'USER_ROLES',
  CONTENT_GROUPS: 'CONTENT_GROUPS',
  DATA: 'DATA',
}

export const SET_USER = `${groups.SETUP}/SET_USER`
export const SET_CLIENT = `${groups.SETUP}/SET_CLIENT`
export const SET_SECURITY_ROLES = `${groups.SETUP}/SET_SECURITY_ROLES`
export const SET_CONTENT_GROUPS = `${groups.SETUP}/SET_CONTENT_GROUPS`

export const UPDATE_ROLE = `${groups.USER_ROLES}/UPDATE_ROLE`
export const CREATE_ROLE = `${groups.USER_ROLES}/CREATE_ROLE`
export const UPDATE_SECURITY_ROLE_USERS = `${groups.USER_ROLES}/UPDATE_SECURITY_ROLE_USERS`
export const UPDATE_USER_ROLE = `${groups.USER_ROLES}/UPDATE_USER_ROLE`
export const DELETE_SECURITY_ROLE = `${groups.USER_ROLES}/DELETE_SECURITY_ROLE`

export const RESET_USER_PASSWORD = `${groups.DATA}/RESET_USER_PASSWORD`
export const GET_CATEGORIES = `${groups.DATA}/GET_CATEGORIES`
export const GET_USERS = `${groups.DATA}/GET_USERS`
export const SET_WEBSOCKET = `${groups.DATA}/SET_WEBSOCKET`
export const GET_EVENTS_ANALYTICS = `${groups.DATA}/GET_EVENTS_ANALYTICS`
export const GET_EVENTS = `${groups.DATA}/GET_EVENTS`
export const GET_EVENT_LOG_ITEMS = `${groups.DATA}/GET_EVENT_LOG_ITEMS`
export const GET_EVENTS_SLIM = `${groups.DATA}/GET_EVENTS_SLIM`
export const GET_FULL_EVENT = `${groups.DATA}/GET_FULL_EVENT`
export const GET_TRANSCRIPT_VOCABULARIES = `${groups.DATA}/GET_TRANSCRIPT_VOCABULARIES`
export const UPDATE_TRANSCRIPT_VOCABULARIES = `${groups.DATA}/UPDATE_TRANSCRIPT_VOCABULARIES`
export const GET_ENCODERS = `${groups.DATA}/GET_ENCODERS`
export const GET_PLAYER_PREFERENCES = `${groups.DATA}/GET_PLAYER_PREFERENCES`
export const STARTED_REQUESTING_EVENT_LOG_ITEMS = `${groups.DATA}/STARTED_REQUESTING_EVENT_LOG_ITEMS`
export const FINISHED_REQUESTING_EVENT_LOG_ITEMS = `${groups.DATA}/FINISHED_REQUESTING_EVENT_LOG_ITEMS`

export const CREATE_CONTENT_GROUP = `${groups.CONTENT_GROUPS}/CREATE_CONTENT_GROUP`
export const UPDATE_CONTENT_GROUP_META = `${groups.CONTENT_GROUPS}/UPDATE_CONTENT_GROUP_META`
export const ADD_CONTENT_GROUP_CATEGORIES = `${groups.CONTENT_GROUPS}/ADD_CONTENT_GROUP_CATEGORIES`
export const REMOVE_CONTENT_GROUP_CATEGORIES = `${groups.CONTENT_GROUPS}/REMOVE_CONTENT_GROUP_CATEGORIES`
export const ADD_CONTENT_GROUP_USER = `${groups.CONTENT_GROUPS}/ADD_CONTENT_GROUP_USER`
export const REMOVE_CONTENT_GROUP_USER = `${groups.CONTENT_GROUPS}/REMOVE_CONTENT_GROUP_USER`
export const DELETE_CONTENT_GROUP = `${groups.CONTENT_GROUPS}/DELETE_CONTENT_GROUP`
